import {
  Component, EventEmitter,
  Input, Output, ViewChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';
import { BrandService } from 'shared/brand/brand.service';
import { ExportManagerService } from 'shared/export-manager/export-manager.service';
import { LoaderComponent } from 'shared/loader/loader.component';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'receivers-modal',
  templateUrl: 'receivers-modal.component.html',
  styleUrls: ['receivers-modal.component.scss'],
})
export class ReceiversModalComponent extends BaseModalComponent {
  data: any[];

  @Input() timezone: any;

  @Output() receiverResend = new EventEmitter();

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  constructor(
    private brandService: BrandService,
    private exportManagerService: ExportManagerService,
  ) {
    super();
  }

  public setData(data: any[]) {
    this.data = data;
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onResendClick(receiverDataId: string) {
    if (this.loader) {
      this.loader.show();
    }
    this.exportManagerService.postResend(this.brandService.getBrand(), receiverDataId)
      .subscribe(() => {
        if (this.loader) {
          this.loader.hide();
        }
        this.receiverResend.emit(receiverDataId);
      });
  }
}
